import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { bonuses } from '../../data/bonuses';
import { padNumber } from '../../utils/format';
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="bg-forest py-14 text-white sm:py-20 lg:py-24" data-id="element-16" data-mp="1s9zmgo9cnh4o">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-17" data-mp="1dd8jy64dppau">
        <SectionHeading id="bonuses-title" eyebrow="5 bonuses included" lead="Plus 5" highlight="teaching resources" intro="Practical extras that sit beside the main guide. All five come with your $27 pack." data-id="element-18" data-mp="1dbnrcm1mkgfm" />

        {/* Mobile: compact swipe row. Tablet/desktop: grid. */}
        <ul aria-label="Included bonuses" className="no-scrollbar -mx-5 mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-2 md:mx-0 md:mt-12 md:grid md:grid-cols-2 md:gap-5 md:overflow-visible md:px-0 lg:grid-cols-3" data-id="element-19" data-mp="2yql3zu2po7wz">
          {bonuses.map((bonus, index) => <li key={bonus.name} className="flex w-[76%] max-w-[300px] shrink-0 snap-center flex-col overflow-hidden rounded-xl border border-white/15 bg-pine md:w-auto md:max-w-none" data-id="element-20" data-mp="c04jghjai1kg" data-mpi={index}>
              <div className="bg-cream p-3 sm:p-4" data-id="element-21" data-mp="kt7xos1reig5">
                <img src={bonus.image} alt={`${bonus.name} cover`} loading="lazy" className="mx-auto block aspect-square h-auto w-full max-w-[260px] object-contain" data-id="element-22" data-mp="kuj1usz49s7s" />
              </div>
              <div className="flex-1 border-t border-white/15 p-5" data-id="element-23" data-mp="7235gb0q0sfu">
                <p className="text-[12px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-24" data-mp="20ngi7vfa1s6">Bonus {padNumber(index + 1)}</p>
                <h3 className="mt-1.5 font-display text-[23px] font-bold uppercase leading-[1.02] sm:text-[26px]" data-id="element-25" data-mp="1iedqtwd4xma9">
                  {bonus.name}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-white/80" data-id="element-26" data-mp="1libcr8hvdqjd">{bonus.benefit}</p>
              </div>
            </li>)}
        </ul>
        <p className="mt-3 flex items-center justify-center gap-1.5 text-sm text-white/65 md:hidden" data-id="element-27" data-mp="1pkznjlq597iz">
          Swipe to see all 5 <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-28" data-mp="1zh2nqm1fqw3a" />
        </p>

        <div className="mt-10 text-center sm:mt-14" data-id="element-29" data-mp="1zeym6ar0e966">
          <CtaButton target="offer" className="w-full sm:w-auto" data-id="element-30" data-mp="11uvkbfgvb9si">
            Get the lesson pack
          </CtaButton>
        </div>
      </div>
    </section>;
}